import { KoStaicMembers, KoText, KoTitle } from "packages";
import styles from "../feed.module.scss";
import TicketLink from "packages/datatable/widgets/ticketLink";
import TaskStatus from "packages/datatable/widgets/taskStatus";
export default function TicketPost({ post }) {
  return (
    <div className={styles.ticketPost}>
      <div className={styles.assignee}>
        <KoText text="Summary" className={styles.label} />
        <KoTitle level={4} text={post?.summary} />
      </div>
      <div className={styles.ticketDetails}>
        <div className={styles.ticketInfo}>
          <div className={styles.assignee}>
            <KoText text="Status" className={styles.label} />
            <TaskStatus
              data={post?.ticketStatus}
              row={post}
              className={styles.ticketStatus}
            />
          </div>
          <div className={styles.assignee}>
            <KoText text="Issue Id" className={styles.label} />
            <TicketLink
              data={post?.taskId}
              row={post}
              className={styles.ticketActivities}
            />
          </div>
        </div>
        <div className={styles.ticketMembers}>
          <div className={styles.assignee}>
            <KoText text="Assignee" className={styles.label} />
            <KoStaicMembers data={post?.assigneeProfile || []} />
          </div>
          <div className={styles.assignee}>
            <KoText text="Reporter" className={styles.label} />
            <KoStaicMembers data={post?.reporterProfile || []} />
          </div>
        </div>
      </div>
    </div>
  );
}
